import { useState, useRef } from 'react';
import { VStack } from '@chakra-ui/react';

import Slider from 'shared/Slider';
import StageCard from './StageCard';
import useMobileStagesAnimation from './useMobileStagesAnimation';

import { RouteMobile } from 'assets/illustrations/stages';
import { stagesCardsData } from 'constants/stages';

const StagesContentMobileView = () => {
  const greenLineRef = useRef(null);
  const [swiper, setSwiper] = useState(null);
  const { handleSlideChange } = useMobileStagesAnimation(greenLineRef);

  return (
    <VStack hideFrom="xt" w="full" gap={{ mobile: '50px', laptop: '85px' }}>
      <RouteMobile greenLineRef={greenLineRef} w="full" h="auto" />

      <Slider
        controller={swiper}
        setController={setSwiper}
        SlideComponent={StageCard}
        slidesData={stagesCardsData}
        useBreakpoints={false}
        freeMode={false}
        onSlideChange={handleSlideChange}
      />
    </VStack>
  );
};

export default StagesContentMobileView;
